export default __webpack_public_path__ + "images/QB.bef4194.png";